import { Dropdown } from 'antd';
import authApi from 'api/auth';
import gameApi from 'api/gameApi';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import casino from 'assets/icons/casino_icon.png';
import casino_dark from 'assets/icons/casino_icon_dark.png';
import home from 'assets/icons/home_icon.png';
import home_dark from 'assets/icons/home_icon_dark.png';
import poker from 'assets/icons/poker_icon.png';
import ConditionButton from 'components/Commons/ConditionButton';
import CurrencySwicher from 'components/Commons/CurrencySwitcher';
import { HeaderProps, ShowModalProps } from 'components/Commons/Header';
import { showInfoModal } from 'components/Modals/CommonModals';
import { IMG_ALT } from 'consts/app';
import CashierModal from 'features/home/components/Modals/CashierModal';
import PromotionModal from 'features/home/components/Modals/PromotionModal';
import UserProfileModal from 'features/home/components/Modals/UserProfileModal';
import AccountSubMenu from 'features/home/components/Submenu/AccountSubMenu';
import SettingSubMenu from 'features/home/components/Submenu/SettingSubMenu';
import {
  onChangeAuthPage,
  selectEvent,
  setBlance,
  setShowEventNoti,
} from 'features/home/homeSlice';
import useThemes from 'hooks/useThemes';
import useUserDetail from 'hooks/useUserDetail';
import { StreamResponse } from 'models/stream';
import React, { Fragment, useMemo, useState } from 'react';
import { CgLogIn } from 'react-icons/cg';
import { FaRegUser, FaUser, FaWallet } from 'react-icons/fa';
import { IoSettingsOutline, IoSettingsSharp } from 'react-icons/io5';
import { MdDarkMode, MdLightMode, MdOutlineArrowBack } from 'react-icons/md';
import { TbFileDescription } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { setClearStateToLogout } from 'redux/userSlice';
import { getLocalStorage, removeLocalStorage } from 'utils/sessionStorage';
const initialState = {
  depositModal: 0,
  isDeposit: true,
  paymentMethodsModal: false,
  achDebitDepositModal: false,
  withdrawModal: false,
  fiatWithdrawModal: false,
  promotionModal: false,
  support: false,
  transferModal: false,
  eventModal: false,
  headerMenu: false,
  userProfile: false,
  userBankbookModal: false,
  cryptoWalletDepositModal: false,
  cryptoWalletWithdrawModal: false,
  vinpayDepositModal: false,
  vinpayWithdrawModal: false,
  walletConnectModal: false,
  tbetBuySellModal: false,
  cashierModal: false,
  vinpayConnect: false,
};
const ServiceMenuBar: React.FC<HeaderProps> = ({
  onShowChangePasswordPage,
  isCasino = false,
  isShowAllPage = false,
  isStreaming = false,
  isShowAllStreaming = false,
  isLiveGame = false,
}) => {
  const { isUserLoggedIn, getUserDetail, getUser } = useUserDetail();
  const t = useAppTranslation();
  const { currentTheme, toggleDarkMode } = useThemes();
  const eventSelected = useAppSelector(selectEvent);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<ShowModalProps>(initialState);
  const [streamChanels, setStreamChanels] = useState<StreamResponse[] | null>();
  const accessToken = getLocalStorage('access_token_terabet');

  const streaming = useMemo(() => {
    if (streamChanels) {
      return streamChanels.some((s) => s.chanelLink !== '') || false;
    }
    return false;
  }, [streamChanels]);

  const logout = async () => {
    const { ok, error } = await authApi.logout({
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (ok) {
      dispatch(setClearStateToLogout());
    }
    if (error && error.unauthorized) {
      dispatch(setClearStateToLogout());
    }
    dispatch(setBlance('0'));
    removeLocalStorage('access_token_terabet');
    removeLocalStorage('kyc_access_token_terabet');
    getUserDetail();
  };

  const onShowLoginPage = () => {
    dispatch(onChangeAuthPage(0));
  };

  const handleShowEventNoti = () => {
    if (eventSelected) {
      dispatch(setShowEventNoti(true));
    } else {
      showInfoModal({
        title: t('popup.comingSoon.title'),
        content: t('popup.comingSoon.content'),
      });
    }
  };

  const handleSetShowModal = (key: keyof ShowModalProps, value: boolean | number) => {
    setShowModal((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCashierClick = () => {
    if (isUserLoggedIn) {
      handleSetShowModal('cashierModal', !showModal.cashierModal);
    } else {
      dispatch(onChangeAuthPage(0));
    }
  };

  const handlePromotionClick = () => {
    handleSetShowModal('promotionModal', !showModal.promotionModal);
  };

  const handleEventClick = () => {
    handleSetShowModal('eventModal', !showModal.eventModal);
  };

  const handleUserProfileClick = () => {
    handleSetShowModal('userProfile', !showModal.userProfile);
  };

  const handleUserBankbookClick = () => {
    handleSetShowModal('userBankbookModal', !showModal.userBankbookModal);
  };

  const handleWalletConnectClick = () => {
    handleSetShowModal('walletConnectModal', !showModal.walletConnectModal);
  };

  const onShowSignUpPage = () => {
    dispatch(onChangeAuthPage(1));
  };

  const handleCasinoClick = () => {
    navigate('/casino');
  };
  const handleStreamingClick = () => {
    navigate('/streaming');
  };

  const handlePokerClick = async () => {
    if (!isUserLoggedIn) {
      window.open(process.env.REACT_APP_POKER_URL, '_blank');
      return;
    }
    setIsLoading(true);
    // window.open(`${window.location.host}/casino/game/poker/play`, '_blank');
    const { ok, body, error } = await gameApi.playPoker();
    setIsLoading(false);
    if (ok && body) {
      window.open(body.url, '_blank');
    }
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleBackClick = () => {
    navigate('/casino');
  };

  const handleBackStreamingClick = () => {
    navigate(-1);
  };

  return (
    <div className="main-header">
      <div className="">
        <div className={`authen-link ${isUserLoggedIn ? 'justify-between' : 'justify-end'}`}>
          {isUserLoggedIn &&
            !isCasino &&
            !isLiveGame &&
            !isShowAllPage &&
            !isShowAllStreaming &&
            !isStreaming && (
              <div className=" currencySwitch">
                <CurrencySwicher />
              </div>
            )}
          {!isCasino ? (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleCasinoClick}
                content={
                  <img
                    src={currentTheme === 'dark' ? casino : casino_dark}
                    alt={IMG_ALT}
                    className="w-5 h-5"
                  />
                }
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.casino')}</p>
            </div>
          ) : (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleHomeClick}
                content={
                  <img
                    src={currentTheme === 'dark' ? home : home_dark}
                    alt={IMG_ALT}
                    className="w-5 h-5"
                  />
                }
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.home')}</p>
            </div>
          )}

          {(isStreaming || isLiveGame) && (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleHomeClick}
                content={
                  <img
                    src={currentTheme === 'dark' ? home : home_dark}
                    alt={IMG_ALT}
                    className="w-5 h-5"
                  />
                }
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.home')}</p>
            </div>
          )}
          {/* {!isStreaming ? (
            <Fragment>
              <div className="authen-button-container">
                <ConditionButton
                  className="authen-button"
                  onClick={handleStreamingClick}
                  content={<CiStreamOn className={`w-5 h-5 ${streaming ? 'streaming-svg' : ''}`} />}
                  isSkipCheckOnClick
                />
                <p className="primary-text-color font-bold"> {t('header.stream')}</p>
              </div>
            </Fragment>
          ) : (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleHomeClick}
                content={
                  <img
                    src={currentTheme === 'dark' ? home : home_dark}
                    alt={IMG_ALT}
                    className="w-5 h-5"
                  />
                }
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.home')}</p>
            </div>
          )} */}

          <div className="authen-button-container">
            <ConditionButton
              className="authen-button"
              onClick={handlePokerClick}
              content={<img src={poker} alt={IMG_ALT} className="w-5 h-5" />}
              isSkipCheckOnClick
            />
            <p className="primary-text-color font-bold"> {t('header.poker')}</p>
          </div>
          {isShowAllPage && (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleBackClick}
                content={<MdOutlineArrowBack className="w-5 h-5" />}
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.back')}</p>
            </div>
          )}
          {isShowAllStreaming && (
            <div className="authen-button-container">
              <ConditionButton
                className="authen-button"
                onClick={handleBackStreamingClick}
                content={<MdOutlineArrowBack className="w-5 h-5" />}
                isSkipCheckOnClick
              />
              <p className="primary-text-color font-bold"> {t('header.back')}</p>
            </div>
          )}

          <div className="authen-link__left">
            <div className="authen-button-container">
              <ConditionButton
                onClick={() => handleCashierClick()}
                className="authen-button"
                content={<FaWallet className="w-5 h-5" />}
                testerCheck={true}
                isSkipCheckOnClick={!isUserLoggedIn}
              />
              <p className="primary-text-color font-bold"> {t('footerMenu.cashier.title')}</p>
            </div>

            {!isUserLoggedIn && (
              <div className="flex-row">
                {/* <div className="authen-button-container">
                  <button
                    id="btn-change-theme"
                    className="header-icon cursor-pointer"
                    onClick={onShowLoginPage}
                  >
                    <CgLogIn className=" primary-text-color w-5 h-5" />
                  </button>
                  <p className="primary-text-color font-bold"> {t('header.login')}</p>
                </div> */}
                <div className="authen-button-container">
                  <button
                    id="btn-change-theme"
                    className="header-icon cursor-pointer"
                    onClick={onShowSignUpPage}
                  >
                    <TbFileDescription className="w-5 h-5 primary-text-color" />
                  </button>
                  <p className="primary-text-color font-bold"> {t('header.register')}</p>
                </div>
              </div>
            )}
          </div>
          <div className="authen-button-container">
            <button
              id="btn-change-theme"
              className="header-icon cursor-pointer"
              onClick={toggleDarkMode}
            >
              {currentTheme === 'light' ? (
                <MdDarkMode className="primary-text-color w-5 h-5" />
              ) : (
                <MdLightMode className="primary-text-color w-5 h-5" />
              )}
            </button>
            <p className="primary-text-color font-bold">{t('footerMenu.theme')}</p>
          </div>
          <Dropdown trigger={['click']} overlay={<SettingSubMenu />}>
            <div className="authen-button-container">
              <button className="header-icon cursor-pointer">
                {currentTheme === 'light' ? (
                  <IoSettingsOutline className="primary-text-color w-5 h-5" />
                ) : (
                  <IoSettingsSharp className="primary-text-color w-5 h-5" />
                )}
              </button>
              <p className="primary-text-color font-bold">{t('footerMenu.setting')}</p>
            </div>
          </Dropdown>
          {isUserLoggedIn ? (
            <>
              <Dropdown
                trigger={['click']}
                overlay={
                  <AccountSubMenu
                    handlePromotionClick={handlePromotionClick}
                    handleEventClick={handleEventClick}
                    handleUserProfileClick={handleUserProfileClick}
                    handleUserBankbookClick={handleUserBankbookClick}
                    handleWalletConnectClick={handleWalletConnectClick}
                    logout={logout}
                  />
                }
              >
                <div className="authen-button-container">
                  <button className="header-icon cursor-pointer">
                    {currentTheme === 'light' ? (
                      <FaUser className="primary-text-color w-5 h-5" />
                    ) : (
                      <FaRegUser className="primary-text-color w-5 h-5" />
                    )}
                  </button>
                  <p className="primary-text-color font-bold"> {t('footerMenu.account')}</p>
                </div>
              </Dropdown>
            </>
          ) : null}
          <div className="flex-row gap-2 w-28 ">
            {!isUserLoggedIn && (
              <div className="authen-button-container">
                <button
                  id="btn-change-theme"
                  className="header-icon cursor-pointer"
                  onClick={onShowLoginPage}
                >
                  <CgLogIn className=" primary-text-color w-5 h-5" />
                </button>
                <p className="primary-text-color font-bold"> {t('header.login')}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <CashierModal
        isOpen={showModal.cashierModal}
        onCancel={handleCashierClick}
        onClose={() => handleSetShowModal('cashierModal', false)}
      />
      <PromotionModal
        title={t('promotion.title')}
        visible={showModal.promotionModal}
        closeModal={handlePromotionClick}
        className="common-modal withdraw-modal"
      />
      <UserProfileModal
        title={t('userProfile.title')}
        visible={showModal.userProfile}
        closeModal={handleUserProfileClick}
        onShowChangePasswordPage={onShowChangePasswordPage}
      />
    </div>
  );
};

export default ServiceMenuBar;
